import { bootstrapApplication } from '@angular/platform-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

function hasMsalAuthResponse(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const payload = `${window.location.hash}&${window.location.search}`;
  return (
    /(^|[?#&])code=/.test(payload) ||
    /(^|[?#&])id_token=/.test(payload) ||
    /(^|[?#&])access_token=/.test(payload) ||
    /(^|[?#&])error=/.test(payload) ||
    /(^|[?#&])client_info=/.test(payload)
  );
}

if (hasMsalAuthResponse()) {
  document.body.replaceChildren();
  void broadcastResponseToMainFrame().catch((err) => {
    console.error('MSAL redirect bridge failed', err);
    bootstrapApplication(AppComponent, appConfig).catch((e) => console.error(e));
  });
} else {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}
